import React from 'react';

const MessageBox = ({ text, classname }) => {
    return (
        <span className={`${classname ? classname : ''} `}>{text}</span>
    )
}

export default MessageBox;